
import { Link, useNavigate } from "react-router-dom";

const NotFound = () => {

  const navigate = useNavigate();

  return (
    <>
     
      <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="flex flex-wrap items-center">
          <div className="hidden w-full xl:block xl:w-1/2">
            <div className="py-17.5 px-26 text-center">
              <Link className="mb-5.5 inline-block" to="/">
                <img
                  className="hidden dark:block"
                  src="https://gp-production-img.s3.ap-southeast-1.amazonaws.com/corp-img/logolight.png"
                  alt="Logo"
                  style={{ width: 200, height: "auto" }}
                />
                <img
                  className="dark:hidden"
                  src="https://gp-production-img.s3.ap-southeast-1.amazonaws.com/corp-img/logolight.png"
                  alt="Logo"
                  style={{ width: 200, height: "auto" }}
                />
              </Link>
              
              <p className="2xl:px-20">
                Memberdayakan Warung, dimana Tradisi Bertemu Inovasi
              </p>

              <span className="mt-15 inline-block">
                <img
                  src="https://gp-production-img.s3.ap-southeast-1.amazonaws.com/corp-img/logokucing.png"
                  alt="kucing-pink"
                />
              </span>
            </div>
          </div>

          <div className="w-full border-stroke dark:border-strokedark xl:w-1/2 xl:border-l-2">
            <div className="w-full p-4 sm:p-12.5 xl:p-17.5">
              <span className="mb-1.5 block font-medium"></span>
              
              <h2 className="mb-9 text-2xl font-bold text-black dark:text-white sm:text-title-xl2">
                404 - Aku tersesaaaaat .....!
              </h2>
              
              <form className={``}>
                

                

                <div className="mb-5">
                  <input
                    type="button"
                    value="Go To Sign In"
                    className="w-full cursor-pointer rounded-lg border border-bersama bg-bersama p-4 text-white transition hover:bg-opacity-90"
                    onClick={() => navigate("/auth/signin")}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
